import { useTranslations } from 'next-intl';

import { UiKitAccordionBase } from '@/fo/ui/kit/accordion/base';
import { UiKitTypographyBase } from '@/fo/ui/kit/typography/base';

import { getData } from '../mock';

import { styles } from './UiArticleSectionFaq.styles';

interface UiArticleSectionFaqProps {
  onClickTypeSkin: () => void;
}

export function UiArticleSectionFaq({
  onClickTypeSkin
}: UiArticleSectionFaqProps) {
  const slots = styles();

  const t = useTranslations('article.section.faq');

  const data = getData(onClickTypeSkin);

  const items = data.questions.map((question) => ({
    header: question.title,
    content: <UiKitTypographyBase>{question.answer}</UiKitTypographyBase>
  }));

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{t('title')}</h2>
      <div>
        <UiKitAccordionBase items={items} />
      </div>
    </div>
  );
}
